import { inject, onMounted, onUnmounted, reactive, nextTick } from "vue";
import { useRoute } from "vue-router";
import { useScrollState } from "@/composables/useScrollState";
import { store } from "../store";
import axiosLib from "axios";

export default function Brands(limit = 0) {
  const axios = inject("axios");
  const route = useRoute();

  // Set offset for scroll loading based on window height
  let offset = 12;
  const windowHeight = window.innerHeight;
  if (windowHeight > 1450) {
    offset = 24;
  } else if (windowHeight > 1100) {
    offset = 18;
  }
  const normalOffset = offset;

  let currentSource = null;
  const CancelToken = axiosLib.CancelToken;

  const brands = reactive({
    loading: false,
    data: [],
    limitData: [],
    error: "",
  });
  const getbrands = (val = null) => {
    let filter = val ? val.value.map((c) => c.slug) : null;
    brands.loading = true;
    let login_req = axios.isLoggedIn ? 1 : 0;
    let user_id = localStorage.getItem('user_id') ?? null;
    axios.api
      .get("/brands", {
        params: {
          category: filter,
          login_req: login_req,
          user_id: user_id
        },
      })
      .then((resp) => {
        if (resp.status) {
          let data = resp.data.data;
          if (store.getters.cart.price_list_id == "33") {
            brands.data = data;
          } else {
            brands.data = data.filter((e) => !e.name.includes("GGG"));
          }
        } else {
          brands.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (brands.loading = false));
  };

  const newBrands = reactive({
    loading: false,
    data: [],
    limitData: [],
    error: "",
  });

  const getNewBrands = () => {
    newBrands.loading = true;
    let login_req = axios.isLoggedIn ? 1 : 0;
    axios.api
      .get("/new-brands", {
        params: {
          login_req: login_req
        }
      })
      .then((resp) => {

        if (resp.status) {
          let data = resp.data.data;
          if (store.getters.cart.price_list_id == "33") {
            newBrands.data = data;
          } else {
            newBrands.data = data.filter((e) => !e.name.includes("GGG"));
          }
        } else {
          newBrands.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (newBrands.loading = false));
  };
  const banner = reactive({
    loading: false,
    data: [],
    name: "",
    image: "",
    error: "",
  });

  const getBanner = async () => {
    banner.loading = true;
    axios.api
      .get("/collection-details?brand_slug=" + route.params.slug)
      .then((resp) => {
        if (resp.status) {
          banner.data = resp.data.data;
        } else {
          banner.error = resp.data.error;
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => (banner.loading = false));
  };

  var page = 1;
  let sort = "";
  let stock = false;

  const brandData = reactive({
    loading: false,
    data: [],
    error: "",
    onScrollLoading: false,
  });

  async function getData(load) {
    let d = {};
    currentSource =  CancelToken.source();
    // const category = store.getters.getSelected.map((r) => r.id);
    // const price = store.getters.getPriceCheck ? store.getters.getPriceRange : 0;
    const category = route.query.category ? route.query.category.split(",") : [];
    const price = route.query.price || 0;
    stock = route.query.stock || false;
    sort = route.query.sort || "";
    let dataToPost = {
      page,
      offset,
      stock,
      sort,
      category,
      min: 0,
      max: price,
    };
    brandData[load] = true;
    if (axios.isLoggedIn) {
      await axios.authApi
        .get("/aCollection?brand_slug=" + route.params.slug, {
          params: dataToPost,
          cancelToken: currentSource.token,
        })
        .then((res) => {
          d = res.data.data;
          if (res.data.filterOptions?.length > 0){
            const filterOptions = res.data.filterOptions;
            selectedOptions(filterOptions);
          }
        }).catch(function(error) {
          if (axiosLib.isCancel(error)) {
            return;
          }
        });
    } else {
      await axios.api
        .get("/collection?brand_slug=" + route.params.slug, {
          params: dataToPost,
          cancelToken: currentSource.token,
        })
        .then((res) => {
          d = res.data.data;
          if (res.data?.filterOptions?.length > 0){
            const nonLoginRequiredOptions = res.data.filterOptions.filter(i => !i.login_required);
            selectedOptions(nonLoginRequiredOptions);
          }
        })
        .catch(function(error) {
          if (axiosLib.isCancel(error)) {
            return;
          }
          if (error.response && error.response.status === 403) {
            // Redirect to login if unauthorized
            window.location.href = "/login";
          }
          console.log(error);
        });
    }
    brandData[load] = false;
    return d;
  }

  // if route has category query param then select those options in filter badge
  const selectedOptions = async (options) => {
    store.dispatch("updateOptions", options);
    if (route.query.category && Array.isArray(options)) {
      const selectedCategories = route.query.category
        .toString()
        .split(",")
        .filter(Boolean);

      const alreadySelected = store.getters.getSelected.map(opt => opt.id?.toString());

      options.forEach(option => {
        if (
          option &&
          option.id !== undefined &&
          selectedCategories.includes(option.id.toString()) &&
          !alreadySelected.includes(option.id.toString())
        ) {
          store.dispatch("selectedOption", {
            ...option,
            type: "category"
          });
        }
      });
    }
  }

  const reset = () => {
    // Cancel previous request if still in progress
    if (currentSource) {
      currentSource.cancel("Canceled due to new request");
    }

    brandData.data = [];
    page = 1;
  };
  async function onSortChanged(v) {
    reset();
    sort = v;
    store.dispatch("setSort", {
      previous: store.getters.getSort.current,
      current: v || "default",
      by : v,
      lastSlug: route.params.slug
    });
    brandData.data = await getData("loading");
  }

  async function onStockChanged(v) {
    reset();
    stock = v;
    maxPrice(stock);
    store.dispatch("setInStock", stock);
    store.dispatch("updateOptions", []);
    store.dispatch("removeOption", "clear");
    // onFilterChanged();
  }

  async function onFilterChanged(v) {
    reset();
    const category = store.getters.getSelected.map((r) => r.id);
    maxPrice(stock, category);
    brandData.data = await getData("loading");
  }

  async function onPriceRangeChanged(v) {
    reset();
    brandData.data = await getData("loading");
    // store.dispatch("removeOption",'clear');
  }

  async function maxPrice(stock = false, category = []) {
    await axios.authApi
      .get("/max-price?brand_slug=" + route.params.slug, {
        params: {
          stock: stock,
          category: category,
        },
      })
      .then((res) => {
        if (res.data.status) {
          store.dispatch("setPriceRange", Number(res.data.data.max_price));
          store.dispatch("setMaxPrice", Number(res.data.data.max_price));
          // store.dispatch("setPriceCheck", false);
        }
      });
  }

  const scrollState = useScrollState();

  function saveScrollState() {
    scrollState.save(route.params.slug, {
      page,
      scrollY: window.scrollY,
    });
  }

  async function restoreScrollState() {
    const saved = scrollState.restore(route.params.slug);
    if (!saved) return false;

    if (saved.page > 1) {
      offset = saved.page * normalOffset;
      page = 1;
      const res = await getData("loading");
      offset = normalOffset;

      if (res?.data) {
        brandData.data = res;
        brandData.data.last_page = Math.ceil(res.total / normalOffset);
        brandData.data.current_page = saved.page;
        page = saved.page;
      }

      await nextTick();
      requestAnimationFrame(() => window.scrollTo({ top: saved.scrollY, behavior: 'smooth' }));
      return true;
    }

    return saved.scrollY;
  }

  async function handleScroll() {
    const itemsContainer = document.querySelector(".items-listing-container");
    if (!itemsContainer) {
      return;
    }
    const canLoadMore = page < brandData.data.last_page;
    const elemScrollHeight = itemsContainer.scrollHeight;
    const elemScrollLoadHeight = elemScrollHeight - elemScrollHeight * 0.5;
    const shouldLoadMore =
      window.pageYOffset + 200 > elemScrollLoadHeight ||
      elemScrollHeight < window.innerHeight ||
      window.pageYOffset + elemScrollLoadHeight < window.innerHeight;

    if (canLoadMore && shouldLoadMore && !brandData.isLoadingScrollData) {
      page++;
      brandData.isLoadingScrollData = true;
      const res = await getData("onScrollLoading");
      brandData.data.current_page = page;
      brandData.data.data?.push(...res.data);
      brandData.isLoadingScrollData = false;
    }
  }

  onMounted(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("beforeunload", saveScrollState);
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("beforeunload", saveScrollState);
  });

  return {
    isLoggedIn: axios.isLoggedIn,
    newBrands,
    getNewBrands,
    brands,
    getbrands,
    banner,
    getBanner,
    brandData,
    getData,
    onSortChanged,
    onStockChanged,
    onFilterChanged,
    onPriceRangeChanged,
    maxPrice,
    reset,
    saveScrollState,
    restoreScrollState,
  };
}
